module.exports = __webpack_public_path__ + "static/media/avisoestudiante.ffcb42c9.png";